//#region Libraries
import styled from "styled-components";
//#endregion

export const Content = styled.ul`
    list-style: none;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 25px;
    background-color: var(--light-blue-2);
    border-radius: 8px;
    padding: 30px 35px;
    margin: 0 35px;
    width: 100vw;
    min-width: 400px;
    max-width: 500px;
`;
export const AboutSchedule = styled.li`
    display: flex;
    gap: 15px;
    margin: 0;
    & span {
        font-size: 14px;
        color: var(--light-gray-5);
    }
`;